module.exports = __webpack_public_path__ + "img/content-education.dcef363c.png";